export default {
  showTropaion: true, // "tropaion" route access
  apiGate: "https://api-gate-staging.eks.spartan.com",
  apiAuth: "https://api-gate-staging.eks.spartan.com/auth",
  apiAccount: "https://api-gate-staging.eks.spartan.com/account",
  apiSportograf: "https://sportograf-staging.eks.spartan.com",
  socketConnectionUrl: "wss://delphi-socket-staging.eks.spartan.com/cable",
  shopUrl: "https://shop-staging.spartan.com",
  authPage: "https://contentful-pet-staging.eks.spartan.com/en",
  stripe: {
    key: "pk_test_zk1D9hwJEa3XSV6wCsIXyiMf",
    keys: {
      us: "pk_test_zk1D9hwJEa3XSV6wCsIXyiMf",
      eu: "pk_test_zk1D9hwJEa3XSV6wCsIXyiMf",
      gb: "pk_test_zk1D9hwJEa3XSV6wCsIXyiMf",
    },
    yearly: {
      productId: "prod_I1RP7KVQpp7r22",
      priceId: "price_1HSmChEClUOaV6ugpWp3CCsm",
    },
    monthly: {
      productId: "prod_J0M31jhCpJMR1k",
      priceId: "price_1IOLLhEClUOaV6ugu0bxZiYY",
    },
  },
  checkout: {
    us: {
      // spartanFoundationQuestionId: "12",
      // spartanPlusTicket: {
      //   ticketTypeId: "6988",
      //   eventId: "176",
      // },
      refundProtectVendorCode: "ven_local_fc75cfeb1a31402f8c75c9822b44e51c",
    },
    ca: {
      refundProtectVendorCode: "ven_local_fc75cfeb1a31402f8c75c9822b44e51c",
    },
    eu: {
      spartanFoundationQuestionId: "35",
      refundProtectVendorCode: "ven_local_fc75cfeb1a31402f8c75c9822b44e51c",
    },
    gb: {
      refundProtectVendorCode: "ven_local_fc75cfeb1a31402f8c75c9822b44e51c",
    },
    ie: {},
  },
  sezzlePublicKey: "sz_pub_xYZ1lNqGPAwcuifLKmNcf5pIKhzau6wo",
  sezzleConfig: {
    mode: "iframe",
    publicKey: "sz_pub_xYZ1lNqGPAwcuifLKmNcf5pIKhzau6wo",
    apiMode: "sandbox",
    isVirtualCard: true,
  },
  contentful: {
    spaceID: "1bk7n9wtl2gh",
    sysId: "3TTtSH50Hn3GE2m4Apul19",
    environment: "nuxt-dev",
    serviceToken:
      "f3426e9333619474060f9862eb4271f221641bfbf08cb4be103e0cd8dbbf7ff2",
    entries: {
      passes: {
        "en-US": "6NQQL8TfCkj1SWtrCaLjsw",
        "en-GB": "6NQQL8TfCkj1SWtrCaLjsw",
        "en-CA": "6NQQL8TfCkj1SWtrCaLjsw",
        "fr-CA": "6NQQL8TfCkj1SWtrCaLjsw",
        "en-FR": "6NQQL8TfCkj1SWtrCaLjsw",
        "fr-FR": "6NQQL8TfCkj1SWtrCaLjsw",
        "en-ES": "6NQQL8TfCkj1SWtrCaLjsw",
        "es-ES": "6NQQL8TfCkj1SWtrCaLjsw",
        "nl-NL": "6NQQL8TfCkj1SWtrCaLjsw",
        "en-NL": "6NQQL8TfCkj1SWtrCaLjsw",
        "it-IT": "6NQQL8TfCkj1SWtrCaLjsw",
        "en-IT": "6NQQL8TfCkj1SWtrCaLjsw",
        "de-DE": "6NQQL8TfCkj1SWtrCaLjsw",
        "en-DE": "6NQQL8TfCkj1SWtrCaLjsw",
        "fi-FI": "6NQQL8TfCkj1SWtrCaLjsw",
        "en-FI": "6NQQL8TfCkj1SWtrCaLjsw",
      },
    },
    contentTypes: {
      charities: "sectionCharityList",
    },
  },
};
